document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');

  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    });

    menu.querySelectorAll('[data-menu-link]').forEach((link) => {
      link.addEventListener('click', () => {
        menu.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Ouvrir le menu');
      });
    });
  }

  const video = document.querySelector('[data-hero-video]');
  const videoToggle = document.querySelector('[data-video-toggle]');
  const heroFilm = document.querySelector('.hero-film');

  if (video && videoToggle) {
    const updateVideoState = () => {
      const paused = video.paused;
      videoToggle.textContent = paused ? '▶' : 'Ⅱ';
      videoToggle.setAttribute('aria-label', paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
    };

    videoToggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      updateVideoState();
    });

    video.addEventListener('play', updateVideoState);
    video.addEventListener('pause', updateVideoState);
    video.addEventListener('timeupdate', () => {
      if (!heroFilm || !Number.isFinite(video.duration)) return;
      heroFilm.classList.toggle('show-brand', video.duration - video.currentTime <= 1.8);
    });
  }
});
